import { now, toHumanReadable } from '@this/shared/dist/tools/datetime.js';
import { saveAs } from 'file-saver';
import { useCallback } from 'react';
import XLSX from 'xlsx';

export type DataTableExport = {
    /**
     * Identifier used to name the exported file.
     */
    identifier: string;

    /**
     * Header of the exported file.
     */
    header: string[][];

    /**
     * Data to be exported.
     */
    data: (
        | string
        | {
              t: string;
              f?: string;
              v?: string | number | Date;
              z?: string;
          }
    )[][];
};

export function useExport(dataExportFunc: () => DataTableExport | null) {
    const onExport = useCallback(() => {
        const dataExport = dataExportFunc();

        if (!dataExport) {
            return;
        }

        const { identifier, header, data } = dataExport;

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet([]);

        XLSX.utils.sheet_add_aoa(worksheet, header);
        XLSX.utils.sheet_add_aoa(worksheet, data, { origin: 'A2' });
        XLSX.utils.book_append_sheet(workbook, worksheet, 'KIM24');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        saveAs(blob, `${identifier}-${toHumanReadable(now(), 'datetime_short_with_seconds_2digit')}.xlsx`);
    }, [dataExportFunc]);

    return { onExport };
}
